import { useState } from "react";
import { connect } from "react-redux";
import { setUser } from "../../../../store/action/auth";
import { settingChanged } from "../../../../store/action/setting";
import HttpService from "../../../../services/http_service/HttpService";
import Http from "../../../../services/http/Http";
import AuthService from "../../../../services/auth/Auth";
import SettingService from "../../../../services/setting/Setting";
import { Warning } from "../../../../components/button";
import { FullScreen } from "../../../../components/dialog";
import Input from "../../../../components/input/Input";
import Textarea from "../../../../components/input/Textarea";
import { Div } from "./style";

const Form = (props) => {
  const {
    settings,
    user,
    data,
    address,
    setAddresses,
    addresses,
    refrence,
    mapRef,
    setUser,
    settingChanged,
  } = props;

  const [isLoadingSendData, setIsLoadingSendData] = useState(false);
  const [state, setState] = useState({
    phone: address?.phone ? address?.phone : "",
    address: "",
  });

  const updateAddress = () => {
    if (isLoadingSendData === false) {
      setIsLoadingSendData(true);

      HttpService(user?.token)
        .patch(`user/addresses/${address?.id}`, {
          phone: state.phone,
          address: state.address ? state.address : data.address_compact,
          default: true,
          lat: data?.geom?.coordinates[1],
          lng: data?.geom?.coordinates[0],
        })
        .then((response) => {
          refrence.current.changeStatus();
          mapRef.current.changeStatus();

          var newAddresses = addresses.map((a) =>
            a.id !== address.id ? a : response?.data?.entity
          );

          setAddresses(newAddresses);

          SettingService.changed(
            settings,
            "services",
            response?.data?.entity?.services,
            settingChanged
          );

          AuthService.setUser(
            {
              ...user,
              address: response?.data?.entity,
            },
            setUser
          );

          Http(response?.status, response?.data?.message, props);
        })
        .catch((error) => {
          Http(error?.response?.status, error?.response?.data?.message, props);
        })
        .finally(() => {
          setIsLoadingSendData(false);
        });
    }
  };

  const handleChange = (stateName, value) => {
    setState({
      ...state,
      [stateName]: value,
    });
  };

  return (
    <FullScreen title="اطلاعات دقیق آدرس" ref={refrence}>
      <Div className="mx-1 mt-2-5 text-right">
        <Input
          name="phone"
          value={state.phone}
          className="mb-2"
          label="تلفن ثابت (اختیاری)"
          placeHolder="تلفن ثابت خود را وارد کنید"
          onChange={handleChange}
          autocomplete="off"
          maxLength="11"
        />
        <Textarea
          name="address"
          value={state.address ? state.address : data.address_compact}
          label="آدرس دقیق"
          placeHolder="آدرس دقیق خود را وارد کنید"
          onChange={handleChange}
        />
        <Warning
          className="d-block mt-3"
          title="ویرایش آدرس"
          placeHolder="توضیحات آدرس خود را وارد کنید"
          onClick={updateAddress}
          isLoading={isLoadingSendData}
          sizeSpinner={20}
        />
      </Div>
    </FullScreen>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    settings: state.settings?.settings,
  };
};

export default connect(mapStateToProps, { setUser, settingChanged })(Form);
